<template>
<!--    服务规格详情-->
    <div class="service-details">
        <Popup :value="show"  :close-on-click-overlay="false" >
            <div class="box">
                <div class="title">
                    <div class="val">{{ title }}</div>
                    <div class="time">服务时长：{{ infos.time }}</div>
                </div>
                <div class="insurance-entry" v-if="infos.insuranceUsedFlag == 1">
                    <div class="duty" @click="checkInsurance(1)">
                        <span>本单责任险</span>
                        <Icon name="arrow" />
                    </div>
                    <div class="space"></div>
                    <div class="accident" @click="checkInsurance(2)">
                        <span>本单意外险</span>
                        <Icon name="arrow" />
                    </div>
                </div>
                <div class="content">
                    <div class="details" v-html="infos.details"></div>
                </div>
            </div>
            <Icon name="close" class="close" @click="$emit('clickClose')" />
        </Popup>
    </div>
</template>

<script>
    import { Popup, Icon, Toast  } from 'vant';
    import { addInsurance } from "@/api/insurance.js";
    import { isAndroid } from '@/utils/isTerminal.js'
    import { gotoNative } from "@/utils/JSBridge.js";
    import Moment from 'moment';

    export default {
        name: 'ServiceDetails',
        props: {
            show:Boolean,
            title: {
                type: String,
                default: '提示'
            },
            infos: Object,
        },
        methods:{
            checkInsurance(type) {
                // type 1 => 意外险； 2 =》 责任险
                // let pdfUrl = 'https://jkhhtest-doc.oss-cn-beijing.aliyuncs.com/insurance/HSJOS190726617497_1.pdf';
                // let URL = encodeURI(pdfUrl);
                // window.location.href = './insurance.html?url=' + URL;
                let nurseId = this.infos.nurseUserId;
                let time = Moment(this.infos.firstServiceTime).format('YYYY-MM-DD');
                addInsurance({nurseId: nurseId, serviceTime: time, type: type}).then(r => {
                    /**
                     * 安卓 pdf 安卓自己打开
                     * ios 直接跳转页面
                     */
                    if (isAndroid) {
                        gotoNative(r.pdfUrl);
                    } else {
                        let URL = encodeURI(r.pdfUrl);
                        window.location.href = './insurance.html?url=' + URL;
                    }
                }).catch(_ => {})
            },
        },
        components:{ Popup, Icon, Toast }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .service-details{
        .van-popup{
            background: none;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .box{
            border-radius: 5px;
            width: 295px;
            display: flex;
            overflow: hidden;
            flex-direction: column;
            align-items: center;
            background: #fff;
            .title{
                display: flex;
                padding: 0 20px;
                overflow: auto;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 50px;
                background: #FCFCFC;
                border-bottom: 1px solid #E3E5E9;
                margin-bottom: 14px;
                .val{
                    color: #222;
                    font-size: 19px;
                }
                .time{
                    color: #222;
                    font-size: 12px;
                }
            }
            .insurance-entry {
                display: flex;
                box-sizing: border-box;
                padding: 0 17px 12px;
                align-content: center;
                justify-content: center;
                .space {
                    width: 17px;
                    height: 27px;
                    flex-grow: 0;
                }
                .duty, .accident {
                    display: inline-flex;
                    width: 123px;
                    flex: 1;
                    height: 27px;
                    align-items: center;
                    justify-content: space-between;
                    background: #FFF6F6;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(248,64,37,1);
                    overflow: hidden;
                    padding: 0 9px;
                    box-sizing: border-box;
                }
            }

            .content{
                line-height: 22px;
                width: 100%;
                padding: 0 24px 30px 20px;
                font-size: 14px;
                color: #222;
                overflow: auto;
                p {
                    word-break: break-all;
                    margin-top: 0;
                    margin-bottom: 0;
                }
                .details {
                    img {
                        display: inline-block;
                        width: 100%;
                    }
                }
            }
        }
        .close{
            font-size: 36px;
            color: #fff;
            margin-top: 30px;
        }
    }

</style>
